import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MacroOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"macro_off"}/>
}
